"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_http_1 = require("@comunica/bus-http");

require("isomorphic-fetch");

var Requester_1 = require("./Requester");
/**
 * A comunica Follow Redirects Http Actor.
 */


var ActorHttpNative =
/*#__PURE__*/
function (_bus_http_1$ActorHttp) {
  _inherits(ActorHttpNative, _bus_http_1$ActorHttp);

  function ActorHttpNative(args) {
    var _this;

    _classCallCheck(this, ActorHttpNative);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorHttpNative).call(this, args));
    _this.userAgent = ActorHttpNative.createUserAgent();
    _this.requester = new Requester_1.default(args.agentOptions ? JSON.parse(args.agentOptions) : undefined);
    return _this;
  }

  _createClass(ActorHttpNative, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", {
                  time: Infinity
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var _this2 = this;

        var options, headers;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = {}; // input can be a Request object or a string
                // if it is a Request object it can contain the same settings as the init object

                if (action.input.url) {
                  options.url = action.input.url;
                  Object.assign(options, action.input);
                } else {
                  options.url = action.input;
                }

                if (action.init) {
                  Object.assign(options, action.init);
                }

                if (options.headers) {
                  headers = {};
                  options.headers.forEach(function (val, key) {
                    headers[key] = val;
                  });
                  options.headers = headers;
                } else {
                  options.headers = {};
                }

                if (!options.headers['user-agent']) {
                  options.headers['user-agent'] = this.userAgent;
                }

                options.method = options.method || 'GET';
                this.logInfo(action.context, "Requesting ".concat(options.url)); // not all options are supported

                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var req = _this2.requester.createRequest(options);

                  req.on('error', reject);
                  req.on('response', function (httpResponse) {
                    httpResponse.on('error', function (e) {
                      httpResponse = null;
                      reject(e);
                    }); // Avoid memory leak on HEAD requests

                    if (options.method === 'HEAD') {
                      httpResponse.destroy();
                    } // using setImmediate so error can be caught should it be thrown


                    setImmediate(function () {
                      if (httpResponse) {
                        // Expose fetch cancel promise
                        httpResponse.cancel = function () {
                          return Promise.resolve(httpResponse.destroy());
                        }; // missing several of the required fetch fields


                        var _headers = new Headers(httpResponse.headers);

                        var result = {
                          body: httpResponse,
                          headers: _headers,
                          ok: httpResponse.statusCode < 300,
                          redirected: options.url !== httpResponse.responseUrl,
                          status: httpResponse.statusCode,
                          // when the content came from another resource because of conneg, let Content-Location deliver the url
                          url: _headers.has('content-location') ? _headers.get('content-location') : httpResponse.responseUrl
                        };
                        resolve(result);
                      }
                    });
                  });
                }));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }], [{
    key: "createUserAgent",
    value: function createUserAgent() {
      return "Comunica/actor-http-native (".concat(typeof window === 'undefined' ? 'Node.js ' + process.version + '; ' + process.platform : 'Browser-' + window.navigator.userAgent, ")");
    }
  }]);

  return ActorHttpNative;
}(bus_http_1.ActorHttp);

exports.ActorHttpNative = ActorHttpNative;